import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-289fcf60"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-sousuo1"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-jiahao"
}, null, -1));
import { onMounted, reactive, ref } from "vue";
import api from "@/api/statement";
import userApi from "@/api/system/users";
import { useStore } from "@/store/index";
import { useI18n } from "vue-i18n";
import { formatDate } from "@/utils";
export default {
  __name: 'index',
  setup(__props) {
    const {
      t
    } = useI18n();
    const store = useStore();
    const userList = ref([]);
    const rules = {
      dates: [{
        required: true,
        message: t("statement.datePlaceholder"),
        trigger: "change"
      }]
    };
    const params = reactive({
      page: 1,
      limit: 10,
      uids: [],
      dates: []
    });
    const list = ref([]);
    const total = ref(0);
    const loading = ref(false);
    onMounted(() => {
      params.dates = defaultDate();
      loadList();
      getUserList();
    });

    // 日期选择器默认7天
    const defaultDate = () => {
      const end = new Date();
      const start = new Date();
      start.setTime(end.getTime() - 7 * 24 * 60 * 60 * 1000);
      console.log([formatDate(start, "YYYYMMDD"), formatDate(end, "YYYYMMDD")]);
      return [formatDate(start, "YYYYMMDD"), formatDate(end, "YYYYMMDD")];
    };
    const loadList = async () => {
      loading.value = true;
      const {
        data: {
          data
        }
      } = await api.list(params);
      total.value = data && data.total || 0;
      list.value = data && data.list || [];
      loading.value = false;
    };
    const getUserList = async () => {
      const {
        data: {
          data
        }
      } = await userApi.selectUser();
      userList.value = data && data.list || [];
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          size: "large",
          inline: true,
          rules: rules
        }, {
          default: _withCtx(() => [_unref(store).info.isManager === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: _ctx.$t('task.list.user')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: params.uids,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.uids = $event),
              multiple: "",
              clearable: "",
              style: {
                "width": "200px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  value: item.id,
                  label: item.name
                }, null, 8, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: _ctx.$t('statement.date'),
            prop: "dates"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: params.dates,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.dates = $event),
              type: "daterange",
              "value-format": "YYYYMMDD",
              "start-placeholder": _ctx.$t('statement.datePlaceholder'),
              "end-placeholder": _ctx.$t('statement.datePlaceholder')
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "success",
              onClick: _cache[2] || (_cache[2] = $event => loadList('query'))
            }, {
              default: _withCtx(() => [_hoisted_2, _createTextVNode(" " + _toDisplayString(_ctx.$t("common.search")), 1)]),
              _: 1
            }), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              onClick: _cache[3] || (_cache[3] = $event => _ctx.handleClick('add'))
            }, {
              default: _withCtx(() => [_hoisted_3, _createTextVNode(" " + _toDisplayString(_ctx.$t("common.add")), 1)]),
              _: 1
            })), [[_directive_permission, '/reply/add']])]),
            _: 1
          })]),
          _: 1
        })]), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          style: {
            "margin-bottom": "20px"
          },
          "row-key": "id"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: _ctx.$t('statement.day'),
            prop: "day"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('task.list.userName'),
            prop: "username"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('statement.assignCnt'),
            prop: "assignCnt"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('statement.calledCnt'),
            prop: "calledCnt"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('statement.connectedCnt'),
            prop: "connectedCnt"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('statement.loginCnt'),
            prop: "loginCnt"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('statement.rechargeCnt'),
            prop: "rechargeCnt"
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            label: _ctx.$t('statement.claimedCnt'),
            prop: "claimedCnt"
          }, null, 8, ["label"])]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _withDirectives(_createVNode(_component_Pagination, {
          total: total.value,
          page: params.page,
          "onUpdate:page": _cache[4] || (_cache[4] = $event => params.page = $event),
          limit: params.limit,
          "onUpdate:limit": _cache[5] || (_cache[5] = $event => params.limit = $event),
          onPagination: loadList
        }, null, 8, ["total", "page", "limit"]), [[_vShow, total.value > 0]])]),
        _: 1
      });
    };
  }
};